import { Box } from 'grommet';
import TalonLogo from 'jsx:@talon/web/public/images/talon-ai-logo.svg';
import { LoadingDots } from '../LoadingDots';

/**
 * A transient bot-side bubble shown in the message list while the LLM is
 * generating a reply. Mirrors the AI_MESSAGE bubble layout from ChatMessage
 * (TalonLogo icon, white bubble, row alignment) but renders LoadingDots as its
 * content. It is driven by the composer's `loading` flag and disappears the
 * moment the real AI_MESSAGE frame arrives — the same WS frame appends the real
 * bot message and clears `loading`, so React swaps the placeholder for the reply
 * in a single render with no flicker.
 */
export const PendingBotMessage = () => (
  <Box flex={false} margin="small" align="end" direction="row">
    <Box align="center" justify="end" margin="xsmall" height="40px" width="40px">
      <TalonLogo />
    </Box>
    <Box
      background="white"
      border={{ color: '#d9d9e3' }}
      round="small"
      pad="small"
    >
      <LoadingDots color="#000" />
    </Box>
  </Box>
);